import type { AppNotification } from "../types/notifications";

export const notifications: AppNotification[] = [
  {
    id: "n1",
    kind: "streak",
    title: "Your 12-day streak is on the line",
    body: "Five minutes keeps it alive. Next up in Spanish: “Buying fruit”.",
    time: "18:40",
    day: "Today",
    read: false,
    href: "/app/learn/en/es/lesson/u4-l3",
    actionLabel: "Keep my streak",
  },
  {
    id: "n2",
    kind: "review",
    title: "Words are due for review",
    body: "Including la bolsa and el recibo, which you saved from the translator.",
    time: "09:15",
    day: "Today",
    read: false,
    href: "/app/learn/en/es/practice",
    actionLabel: "Review now",
  },
  {
    id: "n3",
    kind: "translator",
    title: "“el mercado” showed up in a lesson",
    body: "A word you looked up on Monday was used in “At the market”. It's now Practising.",
    time: "08:02",
    day: "Today",
    read: false,
    href: "/app/words/en/es",
    actionLabel: "See My Words",
  },
  {
    id: "n4",
    kind: "achievement",
    title: "Achievement unlocked: Polyglot starter",
    body: "You're learning three course pairs at the same time.",
    time: "Yesterday",
    day: "Yesterday",
    read: true,
    href: "/app/profile",
  },
  {
    id: "n5",
    kind: "course",
    title: "A new chapter is ready in your book",
    body: "Spanish from English · Chapter 5, “La familia”, can be read now.",
    time: "Yesterday",
    day: "Yesterday",
    read: true,
    href: "/app/learn/en/es/book",
    actionLabel: "Open the book",
  },
  {
    id: "n6",
    kind: "course",
    title: "German from English misses you",
    body: "It's been 4 days. A 3-minute review keeps your A1 words fresh.",
    time: "Mon",
    day: "Earlier this week",
    read: true,
    href: "/app/learn/en/de",
    actionLabel: "Resume German",
  },
  {
    id: "n7",
    kind: "account",
    title: "Your Plus trial ends in 3 days",
    body: "You won't be charged if you cancel before October 3.",
    time: "Mon",
    day: "Earlier this week",
    read: true,
    href: "/app/profile/subscription",
    actionLabel: "Manage plan",
  },
  {
    id: "n8",
    kind: "achievement",
    title: "Weekly recap: 240 XP",
    body: "Up 18% on last week. Listening was your strongest skill.",
    time: "Sun",
    day: "Earlier this week",
    read: true,
    href: "/app/profile",
  },
];
